import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import createPersistedState from 'vuex-persistedstate'
import { modalBuscaAtiva } from './modalBuscaAtiva.js'
import { pagesCategory, permissoes } from '@/services/Permissoes.js'
import utils from '@/mixins/utils.js'

Vue.use(Vuex)

export default new Vuex.Store({
  // salva no armazenamento da sessão usando o vuex-persistedstate, com isso ao recarregar a página o estado do vuex é mantido
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  modules: {
    modalBuscaAtiva: modalBuscaAtiva,
  },
  state: {
    id: '',
    username: '',
    cidade: '',
    cod_ibge: '',
    id_funcao: '',
    funcao: '',
    nu_cnes: null,
    nu_ine: null,
    nu_ine_vinculada: null,
    nu_cns: null,
    micro_area: null,
    unidade_saude: null,
    co_dim_prof: null,
    cos_dim_prof: null,
    accessToken: null,
    permissoes: null, // menus filtrados
    permissoesRaw: null, // objeto cru vindo do banco
    modal_ajuda: [],
    orcamento: null,
    relatorio: {
      capitacaoPonderada: null,
      desempenhoIsf: null,
      informatizacao: null,
    },
    equipesV2: null,
    profissionaisAcs: null,
    ultimaAtualizacao: null,
    sincronizadorC: null,
    infoMunicipio: null,
    ultimaAtualizacaoCadastro: null,
    requiredPasswordUpdate: false,
    pdf: '',
    demonstracao: false,
    npsEfb: '',
    municipios: null,
    microAreas: null,
    regrasIndicadoresAps: null,
    ultimosRegistrosTabelasSincronizadas: null,
    fotoPerfil: null,
    procedimentosIndicadoresAps: null,
    procedimentosIndicadoresApsCarregados: false,
    ajudaHierarchy: {
      tree: {},
      parentMap: {},
      childrenMap: {},
    },
  },
  getters: {
    getOrcamento: (state) => {
      return state.orcamento
    },
    getRelatorio: (state) => {
      return state.relatorio
    },
    getAccessToken: (state) => {
      return state.accessToken
    },
    getCidade: (state) => {
      return state.cidade
    },
    getCodIbge: (state) => {
      return state.cod_ibge
    },
    getModalAjuda: (state) => (card) => {
      return state.modal_ajuda.find((todo) => todo.card === card)
    },
    getId: (state) => {
      return state.id
    },
    getIdFuncao: (state) => {
      return state.id_funcao
    },
    getFuncao: (state) => {
      return state.funcao
    },
    getUltimaAtualizacao: (state) => {
      return state.ultimaAtualizacao
    },
    getSincronizadorC: (state) => {
      return state.sincronizadorC
    },
    getQtdDiasUltimaAtualizacaoC: (state) => {
      return state.qtdDiasUltimaAtualizacaoC
    },
    getProfissionaisAcs: (state) => {
      return state.profissionaisAcs
    },
    getPermissoes: (state) => {
      return state.permissoes
    },
    getUltimaAtualizacaoCadastro: (state) => {
      return state.ultimaAtualizacaoCadastro
    },
    getRequiredPasswordUpdate: (state) => {
      return state.requiredPasswordUpdate
    },
    getRegrasIndicadoresAps: (state) => {
      return state.regrasIndicadoresAps
    },
    getUltimosRegistrosTabelasSincronizadas: (state) => {
      return state.ultimosRegistrosTabelasSincronizadas
    },
    getUltimoRegistroTabelaSincronizadaPorIndicador:
      (state) => (idIndicador) => {
        return (
          state.ultimosRegistrosTabelasSincronizadas.find(
            (el) => el.id_sinc === idIndicador
          ) || null
        )
      },
    getFotoPerfil: (state) => {
      return state.fotoPerfil
    },
  },
  mutations: {
    setDadosFormOrcamento: (state, payload) => {
      state.orcamento.form = payload
    },
    setEmpresa: (state, payload) => {
      state.orcamento.empresa = payload
    },
    setAcrescimo: (state, payload) => {
      state.orcamento.acrescimo = payload
    },
    setParcelaImplantacao: (state, payload) => {
      state.orcamento.parcelaImplantacao = payload
    },
    setPrimeiraContratacao: (state, payload) => {
      state.orcamento.primeiraContratacao = payload
    },
    setOrcamento: (state, payload) => {
      state.orcamento = payload
    },
    setRelatorio: (state, payload) => {
      state.relatorio.capitacaoPonderada = null
      state.relatorio.desempenhoIsf = null
      state.relatorio.informatizacao = null
      state.relatorio.capitacaoPonderada = payload.capitacaoPonderada
      state.relatorio.desempenhoIsf = payload.desempenhoIsf
      state.relatorio.informatizacao = payload.informatizacao
    },
    setPecOnlineOrcamento: (state, payload) => {
      state.orcamento.pec_online = payload.pec_online
    },
    setTreinamento: (state, payload) => {
      state.orcamento.treinamento.ativo = payload.ativo
      state.orcamento.treinamento.tipo = payload.tipo
    },
    setMeaNaApsOrcamento: (state, payload) => {
      state.orcamento.mea_na_aps = payload
    },
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken
    },
    resetRelatorio: (state) => {
      state.relatorio = null
    },
    setDemonstracao: (state, value) => {
      state.demonstracao = value
    },
    logout: (state) => {
      state.accessToken = null
      state.username = ''
      state.id_funcao = ''
      state.funcao = ''
      state.cidade = ''
      state.modal_ajuda = []
      state.cod_ibge = ''
      state.ultimaAtualizacao = null
      state.sincronizadorC = null
      state.equipesV2 = null
      state.profissionaisAcs = null
      state.id = null
      state.nu_cnes = null
      state.nu_ine = null
      state.nu_ine_vinculada = null
      state.nu_cns = null
      state.micro_area = null
      state.unidade_saude = null
      state.co_dim_prof = null
      state.cos_dim_prof = null
      state.permissoes = null
      state.permissoesRaw = null
      state.infoMunicipio = null
      state.pdf = ''
      state.municipios = null
      state.microAreas = null
      state.requiredPasswordUpdate = false
      state.regrasIndicadoresAps = null
      state.ultimosRegistrosTabelasSincronizadas = null
      state.fotoPerfil = null
      state.procedimentosIndicadoresAps = null
      state.procedimentosIndicadoresApsCarregados = false
      state.ajudaHierarchy = {
        tree: {},
        parentMap: {},
        childrenMap: {},
      }
    },
    setUsername(state, name) {
      state.username = name
    },
    setCidade(state, cidade) {
      state.cidade = cidade
    },
    setCodIbge(state, cod_ibge) {
      state.cod_ibge = cod_ibge
    },
    setId(state, id) {
      state.id = id
    },
    setIdFuncao(state, id_funcao) {
      state.id_funcao = id_funcao
    },
    setFuncao(state, funcao) {
      state.funcao = funcao
    },
    setNuIne(state, nu_ine) {
      state.nu_ine = nu_ine
    },
    setNuIneVinculada(state, nu_ine_vinculada) {
      state.nu_ine_vinculada = nu_ine_vinculada
    },
    setNpsEfb(state, data) {
      state.npsEfb = data
    },
    setNuCnes(state, nu_cnes) {
      state.nu_cnes = nu_cnes
    },
    setNuCns(state, nu_cns) {
      state.nu_cns = nu_cns
    },
    setMicroArea(state, micro_area) {
      state.micro_area = micro_area
    },
    setUnidadeSaude(state, unidade_saude) {
      state.unidade_saude = unidade_saude
    },
    setCoDimProf(state, co_dim_prof) {
      state.co_dim_prof = co_dim_prof
    },
    setCosDimProf(state, cos_dim_prof) {
      state.cos_dim_prof = cos_dim_prof
    },
    setMunicipios(state, municipios) {
      state.municipios = municipios
    },
    setMicroAreas(state, micro_areas) {
      state.microAreas = micro_areas
    },
    setModalAjuda(state, st) {
      if (state.modal_ajuda.length == 0) {
        state.modal_ajuda.push(st)
      } else {
        for (const item of state.modal_ajuda) {
          if (item.card.indexOf(st.card) === -1) {
            state.modal_ajuda.push(st)
          }
        }
        // removendo objetos duplicados
        state.modal_ajuda = state.modal_ajuda.filter(function (a) {
          return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true)
        }, Object.create(null))
      }
    },
    setInactiveModalAjuda(state, card) {
      for (const item of state.modal_ajuda) {
        if (item.card === card) {
          item.active = false
        }
      }
    },
    setActiveModalAjuda(state, card) {
      for (const item of state.modal_ajuda) {
        if (item.card === card) {
          item.active = true
        }
      }
    },
    setEquipesV2(state, data) {
      state.equipesV2 = data
    },
    setProfissionaisAcs(state, data) {
      state.profissionaisAcs = data
    },
    setUltimaAtualizacao(state, data) {
      state.ultimaAtualizacao = data
    },
    setSincronizadorC(state, data) {
      state.sincronizadorC = data
    },
    setPdf(state, pdf) {
      state.pdf = pdf
    },
    setProcedimentosIndicadoresAps(state, procedimentos) {
      state.procedimentosIndicadoresAps = procedimentos
      state.procedimentosIndicadoresApsCarregados = true
    },
    resetModalAjuda(state) {
      state.modal_ajuda = []
    },
    resetCidade(state) {
      state.cidade = ''
    },
    setPermissaoRawItem(state, payload) {
      if (!state.permissoesRaw) {
        return
      }

      Vue.set(state.permissoesRaw, payload.key, String(payload.value))
    },
    setPermissoes(state, data) {
      state.permissoesRaw = data

      let obj = {
        dashboard: [],
        administracao: [],
        gestao_cadastros: [],
        visitas_domiciliares: [],
        imunizacao: [],
        vacina_idade_certa: [],
        indicadores_aps: [],
        pre_natal: [],
        doencas_cronicas: [],
        desempenho_por_equipe: [],
        divergencia_vacinas: [],
        saude_crianca: [],
        producao: [],
        obitos: [],
        mudanca_territorio: [],
        vinculo_acompanhamento: [],
        bpa_e_ras: [],
        saude_bucal: [],
        esf_eap: [],
        emulti: [],
        indicadores_esb: [],
        oficinas_treinamentos: [],
        upa: [],
      }

      const perfil = permissoes.find((item) => {
        return (
          item.id_perfil == Number(state.id_funcao) && state.funcao == item.nome
        )
      })

      for (const key in data) {
        // console.log(`${key}: ${data[key]}`)
        for (let index = 0; index < pagesCategory.length; index++) {
          // Ordena o array de acordo com a posição
          let arraySort = perfil[pagesCategory[index].key]
            .map((el, i) => {
              return {
                ...el,
                ordem: i,
              }
            })
            .sort((a, b) => a.ordem - b.ordem)

          let resp = utils.methods.checkCardPermission(
            arraySort,
            key,
            data[key]
          )
          if (resp !== undefined) {
            obj[pagesCategory[index].key].push(resp)
          }
        }
      }
      state.permissoes = obj
    },
    setInfoMunicipio(state, data) {
      state.infoMunicipio = data
    },
    setLogotipo(state, data) {
      state.infoMunicipio.logotipo = data
    },
    setUltimaAtualizacaoCadastro(state, data) {
      state.ultimaAtualizacaoCadastro = data
    },
    setBrasao(state, data) {
      state.infoMunicipio.brasao = data
    },
    setRequiredPasswordUpdate(state, data) {
      state.requiredPasswordUpdate = data
    },
    setRegrasIndicadoresAps(state, data) {
      state.regrasIndicadoresAps = data
    },
    setUltimosRegistrosTabelasSincronizadas(state, data) {
      state.ultimosRegistrosTabelasSincronizadas = data
    },
    setFotoPerfil(state, data) {
      state.fotoPerfil = data
    },
    setAjudaHierarchy(state, payload) {
      state.ajudaHierarchy = payload || {
        tree: {},
        parentMap: {},
        childrenMap: {},
      }
    },
    /**
     * Recalcula os contadores de ajuda dos cards pais em cascata.
     *
     * Utiliza a hierarquia retornada pela API para atualizar os badges
     * dos módulos agregadores quando uma ajuda é marcada como visualizada.
     *
     * Exemplo:
     *
     * mais_acesso_aps
     *   ->> esf_eap
     *      ->> indicadores_aps
     *
     * Ao visualizar "mais_acesso_aps_ajuda":
     *
     * 1. mais_acesso_aps_ajuda é atualizado para 0.
     * 2. esf_eap_qtd_ajuda é recalculado pela soma de seus filhos.
     * 3. indicadores_aps_qtd_ajuda é recalculado pela soma de seus filhos.
     * 4. O processo continua até chegar ao topo da hierarquia.
     *
     * Observações:
     * - Cards pais utilizam a coluna *_qtd_ajuda.
     * - Cards folha utilizam a coluna *_ajuda.
     * - A coluna *_ajuda dos pais representa apenas a ajuda própria da página pai.
     * - Esta função recalcula somente *_qtd_ajuda dos pais.
     * - Não recalcula o dashboard, pois atualmente ele não possui ajuda.
     *
     * @param {Object} state Estado do Vuex.
     * @param {Object} payload
     * @param {String} payload.keyAjuda Chave da ajuda visualizada.
     */
    recalcularQtdAjudaPais(state, payload) {
      // Se não houver permissões ou hierarquia carregadas,
      // não há nada para recalcular.
      if (!state.permissoesRaw || !state.ajudaHierarchy) {
        return
      }

      // Remove o sufixo "_ajuda" para trabalhar apenas com a key.
      // Ex:
      // indicadores_esb_ajuda -> indicadores_esb
      const key = String(payload.keyAjuda || '').replace('_ajuda', '')

      // Mapa filho => pai
      // Ex:
      // {
      //   indicadores_esb: 'indicadores_aps'
      // }
      const parentMap = state.ajudaHierarchy.parentMap || {}

      // Mapa pai => filhos
      // Ex:
      // {
      //   indicadores_aps: [
      //     'esf_eap',
      //     'emulti',
      //     'indicadores_esb'
      //   ]
      // }
      const childrenMap = state.ajudaHierarchy.childrenMap || {}

      /**
       * Retorna o valor que deve ser utilizado na soma.
       *
       * Se o item possuir filhos:
       *   usa *_qtd_ajuda
       *
       * Se for uma folha:
       *   usa *_ajuda
       *
       * Exemplos:
       *
       * indicadores_esb
       *   -> indicadores_esb_qtd_ajuda
       *
       * tratamentos_concluidos
       *   -> tratamentos_concluidos_ajuda
       */
      function getValorAjuda(itemKey) {
        const children = childrenMap[itemKey] || []

        // Se possui filhos, é um agrupador.
        if (children.length > 0) {
          return Number(state.permissoesRaw[`${itemKey}_qtd_ajuda`] || 0)
        }

        // Se não possui filhos, é uma página final.
        return Number(state.permissoesRaw[`${itemKey}_ajuda`] || 0)
      }

      // Se a própria key for um agrupador, recalcula primeiro o seu *_qtd_ajuda.
      // Ex:
      // indicadores_aps_ajuda visualizado -> recalcula indicadores_aps_qtd_ajuda
      if ((childrenMap[key] || []).length > 0 && key !== 'dashboard') {
        const children = childrenMap[key] || []

        const totalFilhos = children.reduce((sum, childKey) => {
          return sum + getValorAjuda(childKey)
        }, 0)

        const totalPai = Number(state.permissoesRaw[`${key}_ajuda`] || 0)
        const total = totalPai + totalFilhos

        Vue.set(state.permissoesRaw, `${key}_qtd_ajuda`, String(total))
      }

      // Obtém o pai direto do item visualizado.
      //
      // Ex:
      // indicadores_esb -> indicadores_aps
      let parentKey = parentMap[key]

      // Percorre todos os pais até chegar ao topo da árvore.
      while (parentKey && parentKey !== 'dashboard') {
        // Obtém todos os filhos do pai atual.
        //
        // Ex:
        // indicadores_aps =>
        // [
        //   'esf_eap',
        //   'emulti',
        //   'indicadores_esb',
        //   'resultado_municipal_indicadores_aps'
        // ]
        const children = childrenMap[parentKey] || []

        // Soma o valor de todos os filhos e também a ajuda própria do pai.
        //
        // Se o filho for agrupador:
        //   usa *_qtd_ajuda
        //
        // Se for folha:
        //   usa *_ajuda
        const totalFilhos = children.reduce((sum, childKey) => {
          return sum + getValorAjuda(childKey)
        }, 0)

        // Soma também a ajuda própria da página pai.
        // Ex:
        // indicadores_aps_ajuda + soma dos filhos
        const totalPai = Number(state.permissoesRaw[`${parentKey}_ajuda`] || 0)
        const total = totalPai + totalFilhos

        // Atualiza a quantidade total de notificações do pai.
        //
        // Ex:
        // indicadores_aps_qtd_ajuda = 8
        Vue.set(state.permissoesRaw, `${parentKey}_qtd_ajuda`, String(total))

        // Sobe para o próximo nível da árvore.
        //
        // Ex:
        // indicadores_esb -> indicadores_aps
        // indicadores_aps -> dashboard
        parentKey = parentMap[parentKey]
      }
    },
  },
  actions: {
    logout({ state, commit, dispatch }) {
      sessionStorage.setItem('vuex', '')
      sessionStorage.clear()
      commit('logout')
      commit('resetModalAjuda')
      commit('resetCidade')
      dispatch('setStatusBuscaAtiva', undefined, { root: true })
      if (state.demonstracao === true) {
        commit('setDemonstracao', false)
        router.push('/demonstracao')
        dispatch('ocultaWidgetBitrix')
        return
      }
      router.push('/login')
      dispatch('ocultaWidgetBitrix')
    },
    ocultaWidgetBitrix() {
      // oculta o widget de chat do bitrix
      const element = window.document.getElementsByClassName(
        'b24-widget-button-wrapper'
      )
      if (element.length > 0) {
        element[0].classList.remove('b24-widget-button-visible')
      }
    },
  },
})
